window.dtMaterialPreparations = function () {
  setSessionValue()

  var material_preparation_datatable = new DataTable('#material-preparations-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#material-preparations-datatable').data('source'),
      data: function (d) {
        d.line_number = $("#datatable-filter-line-number").val(),
        d.planning_date = $("#datatable-filter-planning-date").val()
      },
      beforeSend: function () { showLoadingRow('#material-preparations-datatable', 6); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "action" },
      { "data": "line_number" },
      { "data": "product_name" },
      { "data": "internal_part_id" },
      { "data": "customer_part_number" },
    ],
    columnDefs: [
      {
        targets: [2],
        className: 'text-end'
      },
      {
        targets: [-1,-2],
        className: 'text-nowrap'
      }
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    }
  });

  $(document).off("change", "#datatable-filter-planning-date, #datatable-filter-line-number")
  $(document).on("change", "#datatable-filter-planning-date, #datatable-filter-line-number", function(){
    material_preparation_datatable.ajax.reload()
  })

  dtFinalTouch()
}